// Featured musicals for the homepage carousel

export interface FeaturedMusical {
  storyId: string;
  title: string;
  description: string;
  videoSrc: string;
  audioSrc: string;
  posterSrc: string;
  genre: string;
  verticalFadeEnd?: number;
}

export const featuredMusicals: FeaturedMusical[] = [
  {
    // Sam and the Magical Red Dragon: An Epic Journey Above the Clouds
    storyId: '7eb00336-8c10-4cd4-ae03-e10c2cb2c2e5',
    title: 'Sam and the Magical Red Dragon',
    description: 'An incredible adventure with a magical red dragon',
    videoSrc: '/music/dragon.mp4',
    audioSrc: '/music/dragon.mp3',
    posterSrc: '/music/dragon.jpeg',
    genre: 'Adventure'
  },
  {
    // Princess Rosalind's Magical Town Ball Adventure
    storyId: '1d644c4c-819b-4297-8827-ce779b5bcd93',
    title: "Princess Rosalind's Magical Town Ball",
    description: 'Join Princess Rosalind on a heartwarming adventure',
    videoSrc: '/music/princess.mp4',
    audioSrc: '/music/princess.mp3',
    posterSrc: '/music/princess.jpeg',
    genre: 'Fantasy',
    verticalFadeEnd: 94,
  },
  {
    // Alex Martinez at Hyperion Academy
    storyId: '87ff20d7-6d1e-4305-8f7d-1fa752ba053a',
    title: 'Hyperion Academy: Fire Awakening',
    description: 'From powerless to fierce fire-wielding hero',
    videoSrc: '/music/super.mp4',
    audioSrc: '/music/superhero.mp3',
    posterSrc: '/music/super.jpeg',
    genre: 'Action'
  }
];
